/** Enable product image lightbox in customer-facing and staff preview proposal views. */
export function shouldEnableProposalProductImageLightbox(
  audience?: "customer" | "staff",
): boolean {
  return audience === "customer" || audience === "staff";
}
